const HeroSecondary = (props) => {

  const {
    preTitle,
    title,
    paragraph,
    ctaPrimary,
    ctaSecondary,
    image,
    colorScheme = 'darkGreen',
    video = false
  } = props

  const normalizedData = {
    pretitle: preTitle,
    title,
    paragraph,
    ctaPrimary,
    ctaSecondary,
    image: {
      alt: image.alt,
      src: image.url
    },
    colorScheme,
    video
  }

  return normalizedData
}

export default HeroSecondary
